import CustomDataTable from "../../components/CustomDataTable/CustomDataTable";
import { ENDPOINT } from "../../services/endPoints";
import InformationBox from "../../components/InformativeBox/InformativeBox";
import React from "react";
import SubChildLayout from "../../components/SubChildLayout/SubChildLayout";
import { useOutlet } from "react-router-dom";

const HospitalList = () => {
  const outlet = useOutlet();
  const hospitalId = localStorage.getItem("hospitalId");
  const excludedKeys = [
    "id",
    "updatedAt",
    "patient_DOB",
    "patient_middle_name",
    "dob",
    "phone_number",
    "zip_code",
    "deletedAt",
    "createdAt",
    "question1",
    "question2",
    "question3",
    "education_level",
    "occupation",
    "country_of_origin",
    "disability",
    "permanent_residential_address",
    "inkhundla",
    "chiefdom",
    "current_residential_address",
    "postal_address",
    "primary_cellphone",
    "secondary_cellphone",
    "land_phone",
    "patient_email_id",
    "patient_cmis_id",
    "patient_code",
    "nurses_id",
    "hospital_id",
    "hospital_Name",
    "hospital_region",
    "doctore_comments1",
    "form_filling_year",
    "form_code",
    "doctore_comments2",
    "doctore_comments3",
    "form_accept_reject",
    "form_viewed",
    "year",
    "nurses_region",
    "pf_id",
    "facility_type",
    "patient_gender"
  ];

  

  const compareValue = [
    "id",
    "patient_name",
    "patient_age",
    "patient_DOB",
    "patient_natinal_id",
    "patient_cmis_id",
    "patient_code",
    "nurses_id",
    "facility_name",
    "facility_type",
    "hospital_id",
    "hospital_Name",
    "hospital_region",
    "form_accept_reject",
    "doctore_comments1",
    "form_viewed",
    "form_filling_Date",
    "form_filling_year",
    "form_code",
    "form_type",
    "form_risk_rating",
    "createdAt",
    "updatedAt",
    "deletedAt",
    "pf_id",
    "facility_type",
    "nurse_name"

  ];

  const customKeyName = {
    "patient_name": "Patient Name",
    "patient_age": "Age",
    "patient_DOB": "DOB",
    "patient_natinal_id": "National ID",
    "patient_cmis_id": "CMIS ID",
    "patient_code": "Patient Code",
    "nurses_id": "Nurse ID",
    "facility_name": "Facility Name",
    "facility_type": "Facility Type",
    "hospital_id": "Hospital ID",
    "hospital_Name": "Referred Facility",
    "hospital_region": "Referred Facility Region",
    "form_accept_reject": "Accept/Reject",
    "doctore_comments1": "Dr. Comment",
    "form_viewed": "Form Viewed",
    "form_filling_Date": "Date",
    "form_filling_year": "Form Filling Year",
    "form_code": "Form Code",
    "form_type": "Form Type",
    "form_risk_rating": "Form Risk Rating",
    "nurse_name":"Nurse Name"
};


const customWidth = {
  patient_name: "150px",
  patient_age: "10px",
  patient_gender: "10px",
  patient_natinal_id: "150px",
  facility_name:"150px",
  facility_type:"50px",
  form_filling_Date:"150px",
  form_type:"50px",
  // form_risk_rating:"50px",
};

const conditionalRowStyles = [
  {
    when: row => row.form_viewed === "1",
    style: {
      backgroundColor: 'rgba(127, 255, 0, 0.6)',
    },
  },
  {
    when: row => row.form_viewed === "1" && row.form_accept_reject === "2",
    style: {
      backgroundColor: 'rgba(255, 0, 0, 0.6)',
    },
  },
];


  return (
    outlet || (
      <>
          <CustomDataTable
                tableTitle={"Referred Patient List"}
                endPoint={`${ENDPOINT.PATIENT}/${hospitalId}`}
                filterKey={"patient_name"}
                excludedKeys={excludedKeys}
                hospitalId={hospitalId}
                compareValue={compareValue}
                customKeyName={customKeyName}
                customWidth={customWidth}
                conditionalRowStyles={conditionalRowStyles}
          />
          <InformationBox/>
      </>
    )
  );
};

export default HospitalList;
